export default __webpack_public_path__ + "static/media/5.ae6c2e8b.webp";